// extracted by mini-css-extract-plugin
export default {"GeneralInfo":"GeneralInfo_GeneralInfo__7Kdnz","line":"GeneralInfo_line__b+emr"};